import { useTranslation } from 'react-i18next'
import { Dialog, DialogContent, DialogTitle } from '@/shared/ui/dialog'

interface MediaPreviewDialogProps {
  /** Image to show; `null` keeps the dialog closed. */
  url: string | null
  onClose: () => void
}

/** Full-size preview of an uploaded tour image. */
export function MediaPreviewDialog({ url, onClose }: MediaPreviewDialogProps) {
  const { t } = useTranslation()

  return (
    <Dialog
      open={url !== null}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <DialogContent
        className="max-h-[90vh] max-w-[min(90vw,56rem)] gap-0 overflow-hidden p-2 sm:p-4"
        // * VI: Nút đóng nền tối bo tròn để luôn nhìn rõ trên mọi ảnh sáng/tối | EN: Round dark close button so it stays visible over both light and dark images
        closeClassName="right-4 top-4 flex h-9 w-9 items-center justify-center rounded-full bg-black/60 text-white opacity-100 shadow-md backdrop-blur-sm transition-colors hover:bg-black/80 focus:ring-white focus:ring-offset-0 data-[state=open]:bg-black/60 data-[state=open]:text-white sm:right-6 sm:top-6 [&>svg]:h-5 [&>svg]:w-5"
      >
        <DialogTitle className="sr-only">{t('common.preview')}</DialogTitle>
        {url !== null && (
          <img
            src={url}
            alt=""
            className="max-h-[min(85vh,calc(90vh-4rem))] w-full object-contain"
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
